import { useEffect, useState } from "react";

const Thumbnail = (props) => {
  const { mix, drawerMix, setDrawerMix, setDrawerOpen } = props;

  function replaceAfterLastHyphen(url) {
    const lastHyphenIndex = url.lastIndexOf("-");
    if (lastHyphenIndex === -1) return url; // No hyphen found
    return url.slice(0, lastHyphenIndex + 1) + "t67x67.jpg";
  }

  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    if (mix) {
      setImageUrl(replaceAfterLastHyphen(mix.artworkUrl));
    }
  }, [mix]);

  return (
    <div
      className={`archive__thumb-wrapper ${drawerMix === mix ? "active" : ""}`}
      onClick={() => {
        setDrawerMix(mix);
        setDrawerOpen(true);
      }}
    >
      <img
        className="archive__thumb"
        src={imageUrl}
        alt={`${mix.title}`}
      />
    </div>
  );
};

export default Thumbnail;
